import _ from "lodash";
import client from "lib/apolloClient/client";
import update from "immutability-helper";
import { colors } from "Constants";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import {
  createProcessJournalMutation,
  updateProcessJournalMutation,
  deleteProcessJournalMutation,
} from "./Mutations";
import {
  writeProcessJournalListInCache,
  getProcessJournalListFromCache,
  readProcessJournalFromCache,
  writeProcessJournalInCache,
} from "./GraphqlHelpers";
import { getLearningOutcomesPostsQuery } from "Projects/modules/ProjectQueries";
import { getProcessJournalListQuery } from "./Queries";
import { uploadAttachments } from "Post/modules/PostModule";
import {
  PROJECT_GROUP_TYPE_COMMUNITY,
  PROJECT_GROUP_TYPE_PERSONAL,
  PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
  PROJECT_GROUP_TYPE_DP_CAS,
  PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
  PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
} from "Projects/Constants/stringConstants";
import {
  TEMPLATE_FIELD_SERVICE_ACTION_OUTCOMES_MYP,
  TEMPLATE_FIELD_ATLS_MYP,
  TEMPLATE_FIELD_OBJECTIVES_MYP,
  TEMPLATE_FIELD_CAS_LEARNING_OUTCOMES_DP,
  PLANNER_ELEMENT_DP_CAS_LEARNING_OUTCOMES,
  PLANNER_ELEMENT_MYP_SERVICE_ACTION_OUTCOME,
  ELEMENT_TYPE_MYP_OBJECTIVES,
  ELEMENT_TYPE_MYP_ATL,
  TEMPLATE_FIELD_SL_LEARNING_OUTCOMES_DP,
  TEMPLATE_FIELD_CE_PROCESS_STAGES,
  TEMPLATE_FIELD_CE_PROCESS_DIMENSIONS,
  TEMPLATE_FIELD_CE_PROCESS_PRINCIPLES,
  TEMPLATE_FIELD_CE_LEARNING_OUTCOMES_DP,
  PLANNER_ELEMENT_DP_CP_SL_LEARNING_OUTCOMES,
  PLANNER_ELEMENT_DP_CP_CE_LEARNING_OUTCOMES,
  PLANNER_ELEMENT_COMMUNITY_ENGAGEMENT_PRINCIPLES,
  PLANNER_ELEMENT_COMMUNITY_ENGAGEMENT_STAGES,
  PLANNER_ELEMENT_COMMUNITY_ENGAGEMENT_DIMENSIONS,
} from "Constants/stringConstants";
import { ObjectivesDuotone } from "@toddle-edu/ds-icons";
import { ATTACHMENT_OMIT_ATTRIBUTES } from "store/static";
import {
  getProjectDetailsFromCache,
  writeProjectDetailsInCache,
} from "Projects/modules/ProjectGraphqlHelpers";
import { getCurrentProjectGroupDetails } from "Projects/modules/ProjectModules";
import { getSelectedAcademicYearId } from "modules/CommonSelectors";

// Constants
export const NAME = "processJournal";
export const SET_CURRENT_PROCESS_JOURNAL =
  "SET_CURRENT_PROCESS_JOURNAL" + " " + NAME;
export const RESET_CURRENT_PROCESS_JOURNAL =
  "RESET_CURRENT_PROCESS_JOURNAL" + " " + NAME;
export const SET_CURRENT_PROJECT_ID = "SET_CURRENT_PROJECT_ID" + " " + NAME;

export const TAGGABLE_PROJECT_ELEMENTS = [
  {
    value: TEMPLATE_FIELD_ATLS_MYP,
    label: "common:atls_label",
    tagLabel: "project:tag_atls",
    tagCountBGColor: colors.lightCyan,
    tagCountLabel: "project:atls_tag_count_label",
    projectType: [PROJECT_GROUP_TYPE_PERSONAL, PROJECT_GROUP_TYPE_COMMUNITY],
  },
  {
    value: TEMPLATE_FIELD_SERVICE_ACTION_OUTCOMES_MYP,
    label: "project:service_learning_outcomes",
    tagLabel: "project:tag_sl_outcomes",
    tagCountBGColor: colors.pink700,
    tagCountLabel: "project:service_learning_outcomes_tag_count_label",
    emptyText: "project:empty_message_no_learning_outcomes_selected",
    projectType: [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON],
  },
  {
    value: TEMPLATE_FIELD_OBJECTIVES_MYP,
    label: "common:myp_objectives",
    tagLabel: "project:tag_objectives",
    tagCountBGColor: colors.violet950,
    tagCountLabel: "project:objectives_tag_count_label",
    projectType: [PROJECT_GROUP_TYPE_PERSONAL, PROJECT_GROUP_TYPE_COMMUNITY],
  },
  {
    value: TEMPLATE_FIELD_CE_LEARNING_OUTCOMES_DP,
    label: "project:learning_outcomes",
    tagLabel: "project:tag_ce_learning_outcomes",
    tagCountBGColor: colors.violet950,
    tagCountLabel: "project:learning_outcomes_tag_count_label",
    emptyText: "project:empty_message_no_ce_learning_outcomes_selected",
    projectType: [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT],
    icon: ObjectivesDuotone,
    iconColor: "violet",
  },
  {
    value: TEMPLATE_FIELD_CAS_LEARNING_OUTCOMES_DP,
    label: "project:learning_outcomes",
    tagLabel: "project:tag_cas_learning_outcomes",
    tagCountBGColor: colors.violet950,
    tagCountLabel: "project:learning_outcomes_tag_count_label",
    emptyText: "project:empty_message_no_cas_learning_outcomes_selected",
    projectType: [PROJECT_GROUP_TYPE_DP_CAS],
    icon: ObjectivesDuotone,
    iconColor: "violet",
  },
  {
    value: TEMPLATE_FIELD_SL_LEARNING_OUTCOMES_DP,
    label: "project:learning_outcomes",
    tagLabel: "project:tag_sl_learning_outcomes",
    tagCountBGColor: colors.violet950,
    tagCountLabel: "project:learning_outcomes_tag_count_label",
    emptyText: "project:empty_message_no_cas_learning_outcomes_selected",
    projectType: [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING],
    icon: ObjectivesDuotone,
    iconColor: "violet",
  },
  {
    value: TEMPLATE_FIELD_CE_PROCESS_STAGES,
    label: "project:stage",
    tagLabel: "project:tag_stage",
    tagCountBGColor: colors.violet950,
    tagCountLabel: "project:stage_tag_count_label",
    emptyText: "project:empty_message_no_ce_stages_selected",
    projectType: [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT],
    icon: ObjectivesDuotone,
    iconColor: "violet",
  },
  {
    value: TEMPLATE_FIELD_CE_PROCESS_DIMENSIONS,
    label: "project:dimension",
    tagLabel: "project:tag_dimension",
    tagCountBGColor: colors.violet950,
    tagCountLabel: "project:dimension_tag_count_label",
    emptyText: "project:empty_message_no_ce_dimensions_selected",
    projectType: [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT],
    icon: ObjectivesDuotone,
    iconColor: "violet",
  },
  {
    value: TEMPLATE_FIELD_CE_PROCESS_PRINCIPLES,
    label: "project:principles",
    tagLabel: "project:tag_principle",
    tagCountBGColor: colors.violet950,
    tagCountLabel: "project:principle_tag_count_label",
    emptyText: "project:empty_message_no_ce_principles_selected",
    projectType: [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT],
    icon: ObjectivesDuotone,
    iconColor: "violet",
  },
];

export const FILTER_PUBLISHED = {
  state: "PUBLISHED",
};

export const PROJECT_TEMPLATE_FIELD_OBJECTS = {
  [TEMPLATE_FIELD_ATLS_MYP]: {
    config: {
      plannerElementConfig: {
        type: ELEMENT_TYPE_MYP_ATL,
      },
      fieldTypeConfig: {
        rootNodeDepth: 1,
      },
      type: "PLANNER_ELEMENT",
    },
    viewType: "Nestedview",
    isFullScreen: false,
    isDsComponent: true,
  },
  [TEMPLATE_FIELD_OBJECTIVES_MYP]: {
    config: {
      plannerElementConfig: {
        type: ELEMENT_TYPE_MYP_OBJECTIVES,
        subType: "PERSONAL_OBJECTIVES",
      },
      fieldTypeConfig: {
        rootNodeDepth: 2,
      },
      type: "PLANNER_ELEMENT",
    },
    viewType: "Nestedview",
    isFullScreen: false,
    isDsComponent: true,
  },
  [TEMPLATE_FIELD_SERVICE_ACTION_OUTCOMES_MYP]: {
    config: {
      plannerElementConfig: {
        type: PLANNER_ELEMENT_MYP_SERVICE_ACTION_OUTCOME,
      },
      type: "PLANNER_ELEMENT",
    },
    viewType: "ListView",
    isFullScreen: false,
  },
  [TEMPLATE_FIELD_CAS_LEARNING_OUTCOMES_DP]: {
    config: {
      plannerElementConfig: {
        type: PLANNER_ELEMENT_DP_CAS_LEARNING_OUTCOMES,
      },
      type: "PLANNER_ELEMENT",
    },
    viewType: "ListView",
    isFullScreen: false,
  },
  [TEMPLATE_FIELD_SL_LEARNING_OUTCOMES_DP]: {
    config: {
      plannerElementConfig: {
        type: PLANNER_ELEMENT_DP_CP_SL_LEARNING_OUTCOMES,
      },
      type: "PLANNER_ELEMENT",
    },
    viewType: "ListView",
    isFullScreen: false,
  },
  [TEMPLATE_FIELD_CE_LEARNING_OUTCOMES_DP]: {
    config: {
      plannerElementConfig: {
        type: PLANNER_ELEMENT_DP_CP_CE_LEARNING_OUTCOMES,
      },
      type: "PLANNER_ELEMENT",
    },
    viewType: "ListView",
    isFullScreen: false,
  },
  [TEMPLATE_FIELD_CE_PROCESS_STAGES]: {
    config: {
      plannerElementConfig: {
        type: PLANNER_ELEMENT_COMMUNITY_ENGAGEMENT_STAGES,
      },
      type: "PLANNER_ELEMENT",
    },
    viewType: "ListView",
    isFullScreen: false,
  },
  [TEMPLATE_FIELD_CE_PROCESS_PRINCIPLES]: {
    config: {
      plannerElementConfig: {
        type: PLANNER_ELEMENT_COMMUNITY_ENGAGEMENT_PRINCIPLES,
      },
      type: "PLANNER_ELEMENT",
    },
    viewType: "ListView",
    isFullScreen: false,
  },
  [TEMPLATE_FIELD_CE_PROCESS_DIMENSIONS]: {
    config: {
      plannerElementConfig: {
        type: PLANNER_ELEMENT_COMMUNITY_ENGAGEMENT_DIMENSIONS,
      },
      type: "PLANNER_ELEMENT",
    },
    viewType: "ListView",
    isFullScreen: false,
  },
};

// Actions

export const setCurrentProjectId = data => {
  return {
    type: SET_CURRENT_PROJECT_ID,
    data,
  };
};

export const setLocalProcessJournal = data => {
  return {
    type: SET_CURRENT_PROCESS_JOURNAL,
    data,
  };
};

export const resetLocalProcessJournal = () => {
  return {
    type: RESET_CURRENT_PROCESS_JOURNAL,
  };
};

// Thunk

export const createProcessJournal = params => {
  return async (dispatch, getState) => {
    let title = "";
    let elementPYP = [];
    let attachments = [];
    let studentIds = [];
    let createdAt = "";

    const type = _.get(params, "extraParams.type", null);

    const refetchQueries = [];

    const currentProjectId = params["projectId"];

    switch (type) {
      case "action": {
        title = params["title"];
        elementPYP = params["elementPYP"];
        attachments = params["attachments"];
        studentIds = params["studentIds"];

        refetchQueries.push({
          query: getProcessJournalListQuery,
          variables: {
            id: currentProjectId,
            filters: {
              ..._.get(params, "extraParams.queryVariables", {}),
              orderBy: "PUBLISHED_AT",
            },
          },
        });
        break;
      }
      default: {
        const {
          isProjectGroupTypePortfolio,
          learningOutcomesIds,
          learningOutcomesType,
        } = params || {};
        const processJournalData = _.get(
          getState(),
          "processJournal.localProcessJournal",
          {}
        );

        const cachedData = getProcessJournalListFromCache({
          id: currentProjectId,
        });

        title = processJournalData["title"];
        elementPYP = processJournalData["elementPYP"];
        attachments = processJournalData["attachments"];
        createdAt = processJournalData["createdAt"];
        studentIds = _.map(cachedData.students, student => student.id);

        refetchQueries.push({
          query: getProcessJournalListQuery,
          variables: {
            id: currentProjectId,
            filters: { ...FILTER_PUBLISHED, orderBy: "PUBLISHED_AT" },
          },
        });

        if (currentProjectId && isProjectGroupTypePortfolio) {
          refetchQueries.push({
            query: getLearningOutcomesPostsQuery,
            variables: {
              id: currentProjectId,
              filters: {
                plannerElementIds: learningOutcomesIds,
                plannerElementType: learningOutcomesType,
              },
            },
          });
        }
      }
    }

    const { id: userId } = getState().login.userInfo;
    if (_.size(attachments, 0) > 0)
      attachments = await dispatch(
        uploadAttachments({ attachments, parentId: null, parentType: "POST" })
      );

    try {
      await client.mutate({
        mutation: createProcessJournalMutation,
        variables: {
          input: {
            title,
            studentIds,
            attachments,
            elementsPYP: _.map(elementPYP, item =>
              _.omit(item, ["__typename", "resolvedMinimalTree"])
            ),
            state: "PUBLISHED",
            createdBy: userId,
            parentId: currentProjectId,
            parentType: "PROJECT",
            createdAt,
          },
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });

      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:added", isPlainText: false },
          ],
        })
      );
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }

      throw e;
    }
  };
};

export const updateProcessJournal = params => {
  return async (dispatch, getState) => {
    let title = undefined;
    let elementPYP = [];
    let attachments = [];
    let id = undefined;
    let studentIds = [];
    let createdAt = undefined;

    const type = _.get(params, "extraParams.type", null);

    const refetchQueries = [];
    switch (type) {
      case "action": {
        id = params["id"];
        title = params["title"];
        elementPYP = params["elementPYP"];
        attachments = params["attachments"];
        studentIds = params["studentIds"];
        break;
      }
      default: {
        const processJournalData = _.get(
          getState(),
          "processJournal.localProcessJournal",
          {}
        );

        id = processJournalData["id"];
        title = processJournalData["title"];
        elementPYP = processJournalData["elementPYP"];
        attachments = processJournalData["attachments"];
        createdAt = processJournalData["createdAt"];
      }
    }

    const selectedPost = readProcessJournalFromCache({ id });
    const oldAttachments = _.get(selectedPost, "attachments", []);
    const removedAttachments = _.differenceBy(
      oldAttachments,
      attachments,
      "id"
    );
    const removeAttachmentIds = _.map(removedAttachments, "id");

    const newAttachments = _.map(
      _.differenceBy(attachments, oldAttachments, "id"),
      item => item
    );
    const oldWithAddedAttachmentsArray = [...oldAttachments, ...newAttachments];
    //filtering: only allow new attachments or displaySequence changed attachments
    const addAttachments = _.filter(attachments, (item, index) => {
      const currentAttachment = oldWithAddedAttachmentsArray[index];
      return (
        currentAttachment &&
        (!_.isEqual(currentAttachment.id, item.id) ||
          _.includes(_.get(currentAttachment, "id"), "NEW_") ||
          _.isUndefined(_.get(currentAttachment, "id")))
      );
    });
    // remove unwanted attributes from attachments
    const updatedAddAttachments = _.map(addAttachments, item =>
      _.includes(_.get(item, "id"), "NEW_")
        ? _.omit(item, [...ATTACHMENT_OMIT_ATTRIBUTES, "id"])
        : _.omit(item, ATTACHMENT_OMIT_ATTRIBUTES)
    );

    const attachmentsObject = {
      removeAttachmentIds,
      addAttachments: updatedAddAttachments,
    };

    const { id: userId } = getState().login.userInfo;
    const {
      isProjectGroupTypePortfolio,
      learningOutcomesIds,
      learningOutcomesType,
      projectId,
    } = params || {};

    const selectedPostElementPYPValue = _.last(selectedPost?.elementPYP)?.value;
    const updatingElementPYPValue = _.last(elementPYP)?.value;
    const isUpdatingElementPYPValue =
      _.size(selectedPostElementPYPValue) !== _.size(updatingElementPYPValue);

    if (projectId && isProjectGroupTypePortfolio && isUpdatingElementPYPValue) {
      refetchQueries.push({
        query: getLearningOutcomesPostsQuery,
        variables: {
          id: projectId,
          filters: {
            plannerElementIds: learningOutcomesIds,
            plannerElementType: learningOutcomesType,
          },
        },
      });
    }
    try {
      await client.mutate({
        mutation: updateProcessJournalMutation,
        variables: {
          input: {
            title,
            postId: id,
            studentIds,
            elementsPYP: _.map(elementPYP, item =>
              _.omit(item, ["__typename", "id", "resolvedMinimalTree"])
            ),
            updatedBy: userId,
            state: "PUBLISHED",
            createdAt,

            ...attachmentsObject,
          },
        },
        refetchQueries,
        awaitRefetchQueries: true,
      });

      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:updated", isPlainText: false },
          ],
        })
      );
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }

      throw e;
    }
  };
};

export const updateProcessJournalOptimistic = ({ id, isStarred }) => {
  return async (dispatch, getState) => {
    const { id: userId } = getState().login.userInfo;
    const cachedData = readProcessJournalFromCache({ id });
    writeProcessJournalInCache({
      id,
      data: { ...cachedData, isStarred: !isStarred },
    });
    try {
      await client.mutate({
        mutation: updateProcessJournalMutation,
        variables: {
          input: {
            postId: id,
            updatedBy: userId,
            isStarred: !isStarred,
            state: "PUBLISHED",
          },
        },
      });

      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:updated", isPlainText: false },
          ],
        })
      );
    } catch (e) {
      writeProcessJournalInCache({
        id,
        data: cachedData,
      });
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }

      throw e;
    }
  };
};

export const deleteProcessJournal = ({
  id,
  projectId,
  extraParams: { type, queryVariables = {} } = {},
  learningOutcomesType,
  isProjectGroupTypePortfolio = false,
  learningOutcomesIds,
}) => {
  return async dispatch => {
    let queryParams = {};

    switch (type) {
      case "action": {
        queryParams = queryVariables;
        break;
      }
      default:
        queryParams = FILTER_PUBLISHED;
    }

    const data = getProcessJournalListFromCache({
      id: projectId,
      filters: { ...queryParams, orderBy: "PUBLISHED_AT" },
    });

    writeProcessJournalListInCache({
      variables: {
        id: projectId,
        filters: { ...queryParams, orderBy: "PUBLISHED_AT" },
      },
      data: {
        node: update(data, {
          posts: {
            edges: {
              $set: _.filter(
                _.get(data, "posts.edges", []),
                item => !_.isEqual(_.get(item, "node.id", null), id)
              ),
            },
            totalCount: count => count - 1,
          },
        }),
      },
    });

    try {
      const refetchQueries = [];
      if (projectId && isProjectGroupTypePortfolio) {
        refetchQueries.push({
          query: getLearningOutcomesPostsQuery,
          variables: {
            id: projectId,
            filters: {
              plannerElementIds: learningOutcomesIds,
              plannerElementType: learningOutcomesType,
            },
          },
        });
      }
      await client.mutate({
        mutation: deleteProcessJournalMutation,
        variables: { id },
        refetchQueries,
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:deleted", isPlainText: false },
          ],
        })
      );
    } catch (e) {
      writeProcessJournalListInCache({
        variables: {
          id: projectId,
          filters: { ...queryParams, orderBy: "PUBLISHED_AT" },
        },
        data: {
          node: data,
        },
      });

      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

const REDUCER_HANDLERS = {
  [SET_CURRENT_PROJECT_ID]: (state, action) => {
    return update(state, {
      currentProjectId: { $set: action.data },
    });
  },
  [SET_CURRENT_PROCESS_JOURNAL]: (state, action) => {
    const params = action.data;

    _.forEach(Object.keys(params), key => {
      state = update(state, {
        localProcessJournal: { [key]: { $set: params[key] } },
      });
    });

    return state;
  },
  [RESET_CURRENT_PROCESS_JOURNAL]: (state, action) => {
    return update(state, {
      localProcessJournal: { $set: {} },
    });
  },
};

const initialState = {
  currentProjectId: null,
  localProcessJournal: {},
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

export const markMessagesAsRead = ({ nodeId, badgeKeyToUpdate }) => {
  return async (dispatch, getState) => {
    const projectId = nodeId;
    const { type: projectGroupType } = getCurrentProjectGroupDetails({
      state: getState(),
    });
    const academicYearId = getSelectedAcademicYearId(getState());
    const cachedProjectData = getProjectDetailsFromCache({
      projectId: projectId,
      projectGroupType,
      academicYearId,
    });

    const updatedCachedProjectData = update(cachedProjectData, {
      node: {
        notificationBadgeCounts: {
          [badgeKeyToUpdate]: {
            $set: 0,
          },
        },
      },
    });

    writeProjectDetailsInCache({
      projectId: projectId,
      data: updatedCachedProjectData,
      projectGroupType,
      academicYearId,
    });
  };
};
